/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <g stroke="currentColor" stroke-width="1.5">
      <path
        fill="currentColor"
        d="m16.6497 8.55.225-.3h.3751c1.1045 0 2-.8954 2-2V2.724c0-1.0835-.8887-1.974-2-1.974h-6.4999c-1.1113 0-2 .8905-2 1.974v2.5406l.0043.1425c.0365.5567.3004 1.3108.7238 1.922.4426.6389.911.921 1.2719.921L15 8.25h.75v1.4998l.8997-1.1998Z"
      />
      <path d="M.75 17.9583C.75 13.9824 4.0138 10.75 8 10.75s7.25 3.2324 7.25 7.2083c0 .7134-.5783 1.2917-1.2917 1.2917H2.0417C1.3283 19.25.75 18.6717.75 17.9583Z" />
      <circle cx="8" cy="7" r="3.25" fill="currentColor" />
    </g>
    <defs></defs>
  </React.Fragment>,
  'SidebarSupport'
);
